module.exports = __webpack_public_path__ + "img/praise_img.5ddc215f.png";